
  import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({})

  export default class SoundWave extends Vue {
    @Prop({default: () => '#03A9F4'}) private color!: string;

    private mounted() {
      document.documentElement.style.setProperty('--color', this.color);
    }
  }
